module.exports = __webpack_public_path__ + "img/speaker.ed52476d.png";